import React from "react";


const ResetPass = () => {

return(
    <>

        <div className="mt-20 flex items-center justify-center">
      <div className="w-full max-w-md p-4 md:p-8 bg-white rounded-lg shadow-md md:h-auto flex flex-col justify-center mx-4 my-4 md:mx-0 md:my-0">
        <img className="w-48 md:w-80 mb-8 md:mb-20 mx-auto" src="/images/logo.webp" alt="Logo" />
        
        <form className="space-y-4">
          <input
            type="text"
            placeholder="Username"
            className="w-full p-2 border rounded"
            required
          />

          <div className="flex gap-10 justify-center">
            <button
              type="submit"
              className="w-auto md:w-40 p-2 bg-black text-white rounded hover:bg-gray-800 transition"
            >
              Change password
            </button>
          </div>
        </form>
      </div>
    </div>
    </>
 )
}

export default ResetPass